import React, { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const getInitial = () => {
    try {
      return localStorage.getItem("narwhal_lang") || "es";
    } catch (e) {
      return "es";
    }
  };
  const [lang, setLang] = useState(getInitial);

  const changeLang = useCallback((next) => {
    setLang(next);
    try {
      localStorage.setItem("narwhal_lang", next);
    } catch (e) {}
  }, []);

  const toggle = useCallback(() => {
    changeLang(lang === "es" ? "en" : "es");
  }, [lang, changeLang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang: changeLang, toggle }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
